import { Users } from 'lucide-react'
import React from 'react'
interface InterestBubblesProps {
  count: number
}

export const CompetitionCount: React.FC<InterestBubblesProps> = ({ count }) => {
  return (
    <div className="mb-2 flex items-center">
      <Users className="mr-1 size-4 text-muted" />
      <span>
        <span className="text-primary">
          {count === 0 && 'No one'}
          {count === 1 && '1 person'}
          {count > 1 && `${count} people`}
        </span>
        <span className="text-muted">
          {count === 0 && ' has'}
          {count === 1 && ' has'}
          {count > 1 && ' have'}
        </span>
        <span className="text-muted"> shown interest</span>
      </span>
    </div>
  )
}
